import { z } from '@lucidlink/dto/z';
import { remapZodErrors } from '@lucidlink/uicore';
export const customerIdValidator = z
    .string()
    .min(1, 'aws.contract.customerId.required');
export const productCodeValidator = z
    .string()
    .min(1, 'aws.contract.productCode.required');
export const awsContractFormSchema = z.object({
    customerId: customerIdValidator,
    productCode: productCodeValidator,
});
export const customerIdValidation = (value) => {
    const result = customerIdValidator.safeParse(value);
    return {
        isValid: result.success,
        errors: result.success ? [] : remapZodErrors(result.error.issues),
    };
};
export const productCodeValidation = (value) => {
    const result = productCodeValidator.safeParse(value);
    return {
        isValid: result.success,
        errors: result.success ? [] : remapZodErrors(result.error.issues),
    };
};
export const customerIdRules = [
    {
        errorCodes: ['aws.contract.customerId.required'],
        label: 'Customer ID is required',
    },
];
export const productCodeRules = [
    {
        errorCodes: ['aws.contract.productCode.required'],
        label: 'Product Code is required',
    },
];
